import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AUTH_EVENT = 'auth-changed';

const readAuth = () => {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('user')) || null;
  } catch {
    user = null;
  }
  const token = localStorage.getItem('token') || null;
  return { user, token };
};

export default function useAuth() {
  const navigate = useNavigate();

  const [{ user, token }, setAuth] = useState(readAuth);

  useEffect(() => {
    const sync = () => setAuth(readAuth());
    window.addEventListener('storage', sync);
    window.addEventListener(AUTH_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(AUTH_EVENT, sync);
    };
  }, []);

  const isLoggedIn = !!token;
  const isAdmin = user?.role === 'admin' || user?.role === 'manager';

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.dispatchEvent(new Event(AUTH_EVENT));
    navigate('/login');
  };

  return {
    user,
    token,
    isLoggedIn,
    isAdmin,
    logout,
  };
}
